import React, { ReactNode } from 'react';

export interface ButtonProps {
  buttonType?: 'button' | 'submit' | 'reset' | undefined;
  dataButtonVariation?: '' | 'primary' | 'outline' | 'no-outline' | undefined;
  dataButtonType?: 'control' | undefined;
  dataSize?: 'sm' | undefined;
  additionalClasses?: string;
  disabled?: boolean;
  children: ReactNode;
  onButtonClick?: (event: any) => void;
}

/**
 * Button base component. Leverages Material UI design styling.
 */
const Button: React.FC<ButtonProps> = ({
  buttonType = 'button',
  dataButtonType = '',
  disabled = false,
  children,
  additionalClasses,
  dataButtonVariation = 'standard',
  dataSize = '',
  onButtonClick,
}) => {
  return (
    <button
      disabled={disabled}
      data-button-type={dataButtonType}
      data-button-variation={dataButtonVariation}
      data-size={dataSize}
      onClick={onButtonClick}
      type={buttonType}
      className={additionalClasses}
    >
      {children}
    </button>
  );
};
export default Button;
